import { EditableCompletionTimeField } from '~/partials/EditableCompletionTime';
import { useFieldContext } from '~/util/hooks/useFormContext';
import { FieldLabelWithError } from './FieldLabelWithError';
import type { FieldWithErrorProps } from './FieldLabelWithError';
import { useDisableFormContext } from '../DisableContext';

export function CompletionTimeField({ ...labelProps }: FieldWithErrorProps) {
    const field = useFieldContext<number | null>();
    const disabled = useDisableFormContext();
    return (
        <FieldLabelWithError<number | null> {...labelProps}>
            <EditableCompletionTimeField
                completionTime={field.state.value ?? 0}
                setCompletionTime={(value) =>
                    field.handleChange(value && value > 0 ? value : null)
                }
                disabled={disabled}
            />
        </FieldLabelWithError>
    );
}
